import { OrderState } from "@/enum/orderState";
import { Address } from "./address";
import { Price } from "./price";
import { Shipment } from "./shipment";

export class Order {
  id?: string;
  reference?: string;
  billingDetails?: BillingDetails;
  transferDetails?: string;
  orderState?: OrderState;
  cancellationState?: string;
  shipments?: Shipment[];
  paymentDate?: Date;
  totalPrice?: Price;
  shippingPrice?: Price;
  discountPrice?: Price;
  billingAddress?: Address | null;
  shippingAddress?: Address | null;
  eventHistory?: any;
  coupon?: any;

  public static of(data: any): Order {
    const o: Order = new Order();

    o.id = data.id;
    o.reference = data.reference;
    o.billingDetails = BillingDetails.of(data.billingDetails);
    o.transferDetails = data.transferDetails;
    o.orderState = data.orderState;
    o.cancellationState = data.cancellationState;
    o.shipments = [];
    for (const shipment of data.shipments) {
      o.shipments.push(Shipment.of(shipment));
    }

    o.paymentDate = new Date(data.paymentDate);
    o.totalPrice = Price.of(data.totalPrice);
    o.shippingPrice = Price.of(data.shippingPrice);
    o.discountPrice = Price.of(data.discountPrice);
    o.shippingAddress = data.shipments[0].address ? Address.of(data.shipments[0].address) : null;
    o.billingAddress = data.billingAddress ? Address.of(data.billingAddress) : null;
    o.eventHistory = EventHistory.of(data.eventHistory, o.shipments);
    o.coupon = data.coupon ? Coupon.of(data.coupon) : null;

    return o;
  }
}

export class Coupon {
  cartPriceRuleId?: string;
  code?: string;
  description?: string;
  id?: string;
  name?: string;

  public static of(data: any) {
    const c = new Coupon();

    c.cartPriceRuleId = data.cartPriceRuleId;
    c.code = data.code;
    c.description = data.description;
    c.id = data.id;
    c.name = data.name;

    return c;
  }
}

export class EventHistory {
  PROCESSING?: any;
  SHIPPED?: any;

  public static of(eventHistory: any, shipments?: Shipment[]): EventHistory {
    const e = new EventHistory();

    if (eventHistory["PROCESSING"]) {
      e.PROCESSING = { date: eventHistory["PROCESSING"] };
    }
    if (eventHistory["SHIPPED"]) {
      const trackings: any = [];
      shipments?.forEach((s: Shipment) => {
        trackings.push({ number: s?.trackingInfo?.trackingNumber, url: s?.trackingInfo?.trackingUrl });
      });
      e.SHIPPED = { date: new Date(), trackings };
    }

    return Object.entries(e)
      .sort((a: any, b: any) => new Date(a[1]).getTime() - new Date(b[1]).getTime())
      .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
  }
}

export class BillingDetails {

  paymentMethod?: string;
  transactionNumber?: string;

  public static of(data: any): BillingDetails {
    const b: BillingDetails = new BillingDetails();

    b.paymentMethod = data.paymentMethod;
    b.transactionNumber = data.transactionNumber;
    return b;
  }
}